// HomeSection.jsx
import React, { useRef } from 'react';
import { Link } from 'react-scroll';
import '../styles/HomeSection.css';
import TennisHomepage from '../assets/TennisHomepage.jpeg';
import { useSectionReveal } from '../hooks/useSectionReveal';

function HomeSection() {
  const sectionRef = useRef(null);
  useSectionReveal(sectionRef);

  return (
    <section
      className="home-section"
      id="home"
      style={{ backgroundImage: `url(${TennisHomepage})` }}
      ref={sectionRef}
    >
      <div className="home-content">
        <h1 className="hero-title">
          Unleash Your Tennis <br /> 
          Potential: <br />
          Expert Coaching
        </h1>
        <p>Discover the joy of tennis with my personalized coaching approach. Whether you're a seasoned player or a beginner.</p>
        {/* Scrolls to the Enrollment Form */}
        <Link to="enroll" smooth={true} duration={300} className="enroll-button">Enroll Now</Link>
      </div>
    </section>
  );
}

export default HomeSection;
